import { cn } from "@/lib/utils";

interface LiveBadgeProps {
  /** Conteúdo dentro do badge (ex: "ao vivo · Qui 19h"). */
  children: React.ReactNode;
  className?: string;
}

/**
 * Pill com dot pulsante verde-vivo. Uso institucional discreto — não chama
 * atenção exagerada, apenas sinaliza "ao vivo agendado".
 */
export const LiveBadge = ({ children, className }: LiveBadgeProps) => {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full px-3 py-1.5",
        "bg-[#112711] text-[#D1F8E2]",
        "text-[11px] font-semibold tracking-[0.1em] uppercase",
        "ring-1 ring-[#4BD084]/30",
        className
      )}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#4BD084] opacity-75 motion-reduce:hidden" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#4BD084]" />
      </span>
      {children}
    </span>
  );
};
